import React, { useEffect, useRef, useMemo } from 'react';
import { useReportExport } from '../../context/ReportExportContext';

const ReportSection = ({ 
  id, 
  title, 
  description, 
  children, 
  className = '',
  exportHint = {}
}) => {
  const { registerSection, unregisterSection } = useReportExport();
  const elementRef = useRef(null);

  // Memoize exportHint to prevent unnecessary re-registrations
  // Only re-memoize if exportHint keys/values actually change
  const stableExportHint = useMemo(() => {
    return exportHint || {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportHint?.preferLandscape, exportHint?.expandTableRowsTo]);

  useEffect(() => {
    if (!id) return;

    // Wait for element to be mounted
    const timer = setTimeout(() => {
      if (elementRef.current) {
        registerSection({
          id,
          title,
          description,
          elementRef,
          exportHint: stableExportHint
        });
      }
    }, 0);

    return () => {
      clearTimeout(timer);
      if (id) {
        unregisterSection(id);
      }
    };
  }, [id, title, description, registerSection, unregisterSection, stableExportHint]);

  return (
    <div 
      ref={elementRef}
      className={className}
      data-export-section-id={id}
    >
      {children}
    </div>
  );
};

export default ReportSection;

